module.exports = __webpack_public_path__ + "img/card_1.6d9166af.png";